import { useMemo } from 'react';
import { useViewport } from './use-viewport';
import { 
  calculateEagerThreshold, 
  getGridLayout, 
  isAboveTheFold,
  ViewportDimensions, 
  GridLayout 
} from '@/lib/image-loading-utils';

interface UseImageLoadingThresholdOptions {
  componentType: 'places' | 'spots' | 'photos' | 'custom';
  customGridLayout?: GridLayout;
  buffer?: number;
  maxThreshold?: number;
  considerHeaderHeight?: number;
}

export const useImageLoadingThreshold = (options: UseImageLoadingThresholdOptions) => {
  const viewport = useViewport();
  const { 
    componentType, 
    customGridLayout, 
    buffer = 2, 
    maxThreshold = 25, 
    considerHeaderHeight = 0 
  } = options;

  const threshold = useMemo(() => {
    const gridLayout = customGridLayout || getGridLayout(viewport, componentType);
    
    return calculateEagerThreshold(viewport, gridLayout, {
      buffer,
      maxThreshold,
      considerHeaderHeight,
    });
  }, [viewport, componentType, customGridLayout, buffer, maxThreshold, considerHeaderHeight]);

  const gridLayout = useMemo(() => {
    return customGridLayout || getGridLayout(viewport, componentType);
  }, [viewport, componentType, customGridLayout]);

  return {
    threshold,
    gridLayout,
    viewport,
    isAboveTheFold: (index: number) => {
      return isAboveTheFold(index, viewport, gridLayout, {
        considerHeaderHeight,
      });
    },
  };
}; 